export const DB_LIMITS = {
  facilities: 16,
  care_areas: 32,
  advisories: 800,
  drugs: 10000,
  therapies: 500,
} as const;
